import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useSessionContext } from '@supabase/auth-helpers-react';

import AppNavbar from './components/Navbar';

import LoginPage from './routes/Login/LoginPage';
import RecuperarPasswordPage from './routes/Login/RecuperarPasswordPage';
import ServiciosPage from './routes/Servicios/ServiciosPage';
import VencimientosPage from './routes/Vencimientos/VencimientosPage';
import PartidasPage from './routes/Partidas/PartidasPage';

export default function App() {
  const { isLoading, session } = useSessionContext();
  const location = useLocation();

  const isLoggedIn = !isLoading && session !== null;
  const isLoginOrRecovery =
    location.pathname === '/login' || location.pathname === '/recuperar';

  if (isLoading) {
    return (
      <div className='app-session-loader' role='status' aria-live='polite'>
        <Spinner animation='border' variant='success' />
        <span>Cargando...</span>
      </div>
    );
  }

  return (
    <div className='app-bg-overlay'>
      {isLoggedIn && !isLoginOrRecovery && <AppNavbar />}

      <Routes>
        <Route
          path='/login'
          element={isLoggedIn ? <Navigate to='/servicios' replace /> : <LoginPage />}
        />
        <Route path='/recuperar' element={<RecuperarPasswordPage />} />

        <Route element={isLoggedIn ? <Outlet /> : <Navigate to='/login' replace />}>
          <Route path='/' element={<Navigate to='/servicios' replace />} />

          <Route path='/servicios' element={<ServiciosPage />} />

          <Route
            path='/vencimientos'
            element={<Navigate to='/vencimientos/listado' replace />}
          />

          <Route path='/vencimientos/listado' element={<VencimientosPage />} />
          <Route path='/vencimientos/nuevo' element={<ServiciosPage />} />
          <Route path='/partidas' element={<PartidasPage />} />
        </Route>

        <Route path='*' element={<Navigate to='/servicios' replace />} />
      </Routes>
    </div>
  );
}
